const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const MessageModal = require("./MessageModal");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const RangeSlider = require("./RangeSlider");
const SettingsButtonContainer = require("./SettingsButtonContainer");
const AT = require("../vault/ActionTypes");
const Sounds = require("../util/Sounds");
const AssetsUtil = require("../util/AssetsUtil");
const ColorUtil = require("../util/ColorUtil");
const OpsUser = require("../vault/OpsUser");
const {
	PENCIL_LINE_WIDTHS,
	DEFAULT_SOUNDS_VOLUME,
} = require("../../../shared/Constants");

const styles = require("./styles/SettingsModal.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	return withVaultDispatch(Component);
};

module.exports = augment(
	createReactClass({
		displayName: "SettingsModalView",

		propTypes: {
			onClose: PT.func.isRequired,
			user: PT.object.isRequired,
			demo: PT.bool,
			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		UNSAFE_componentWillMount: function() {
			this.cS = ColorUtil.getCurrentScheme();
			this.pencilColors = ColorUtil.DRAWVAS_COLOR_OPTIONS;
			this.pencilLineWidths = PENCIL_LINE_WIDTHS;
			this.pencilColorFunctions = _.map(this.pencilColors, color => ctx =>
				this.drawPencilColorIcon(ctx, color)
			);
			this.pencilLineWidthFunctions = _.map(
				this.pencilLineWidths,
				width => ctx => this.drawPencilLineIcon(ctx, width)
			);
			this.hadMusic = Sounds.isMusicPlaying();
			if (!this.hadMusic) {
				Sounds.playMusic("general-background");
			}
		},

		componentWillUnmount: function() {
			//Flush any pending updates
			this.debouncedDispatch.flush();
			if (!this.hadMusic) {
				Sounds.stopMusic(true);
			}
		},

		getInitialState: function() {
			this.debouncedDispatch = _.debounce(this.props.dispatch, 500);
			return (
				{
					musicEnabled: OpsUser.isMusicEnabled(this.props.user),
					soundsEnabled: OpsUser.areSoundsEnabled(this.props.user),
					musicVolume: OpsUser.getMusicVolume(this.props.user),
					soundsVolume: OpsUser.getSoundsVolume(this.props.user),
					pencilColor: OpsUser.getPencilColor(this.props.user),
					pencilLineWidth: OpsUser.getPencilLineWidth(this.props.user),
				} || {}
			);
		},

		onClose: function() {
			this.props.onClose();
		},

		getNewUserSettings: function(updates) {
			return _.extend(
				{
					musicEnabled: this.state.musicEnabled,
					musicVolume: this.state.musicVolume,
					pencilColor: this.state.pencilColor,
					pencilLineWidth: this.state.pencilLineWidth,
					soundsEnabled: this.state.soundsEnabled,
					soundsVolume: this.state.soundsVolume,
				},
				updates
			);
		},

		onMusicToggle: function() {
			const volume = this.state.musicVolume;
			const isEnabled = !this.state.musicEnabled;
			let settings = {musicEnabled: isEnabled};
			if (!volume) {
				this.musicSlider.setValue(DEFAULT_SOUNDS_VOLUME);
				settings = {
					musicEnabled: true,
					musicVolume: DEFAULT_SOUNDS_VOLUME,
				};
			} else if (isEnabled) {
				this.musicSlider.setValue(volume);
			} else {
				this.musicSlider.setValue(0);
			}
			Sounds.playSound("thud");
			this.updateSettings(this.getNewUserSettings(settings));
		},

		onSoundToggle: function() {
			const volume = this.state.soundsVolume;
			const isEnabled = !this.state.soundsEnabled;
			let settings = {soundsEnabled: isEnabled};
			if (!volume) {
				this.soundsSlider.setValue(DEFAULT_SOUNDS_VOLUME);
				settings = {
					soundsEnabled: true,
					soundsVolume: DEFAULT_SOUNDS_VOLUME,
				};
				Sounds.playSound("thud");
			} else if (isEnabled) {
				Sounds.playSound("thud");
				this.soundsSlider.setValue(this.state.soundsVolume);
			} else {
				this.soundsSlider.setValue(0);
			}
			this.updateSettings(this.getNewUserSettings(settings));
		},

		onMusicVolumeChange: function(value) {
			const update = {musicVolume: value};
			if (value) {
				update.musicEnabled = true;
			}
			this.updateSettings(this.getNewUserSettings(update));
		},

		onSoundVolumeChange: function(value) {
			const update = {soundsVolume: value};
			if (value) {
				update.soundsEnabled = true;
			}
			this.updateSettings(this.getNewUserSettings(update));
		},

		onPencilColorChange: function(newValue) {
			Sounds.playSound("thud");
			const update = {pencilColor: newValue};
			this.updateSettings(this.getNewUserSettings(update));
		},

		onPencilLineWidthChange: function(newValue) {
			Sounds.playSound("thud");
			const update = {pencilLineWidth: newValue};
			this.updateSettings(this.getNewUserSettings(update));
		},

		updateSettings: function(updateData) {
			updateData.type = this.props.demo
				? AT.UPDATE_TEMP_USER_SETTINGS
				: AT.UPDATE_USER_SETTINGS;
			this.debouncedDispatch(updateData);
			this.setState(updateData);
		},

		// Draw icons that control pencil color.
		drawPencilColorIcon: function(ctx, color) {
			const w = ctx.getWidth();
			const h = ctx.getHeight();
			const colorSide = 0.4 * w;
			ctx
				.sv()
				.bp()
				.rect(0.3 * w, 0.3 * h, colorSide, colorSide)
				.fill(color)
				.rs();
		},

		// Draw icons that control pencil line width.
		drawPencilLineIcon: function(ctx, thickness) {
			const w = ctx.getWidth();
			const h = ctx.getHeight();
			ctx.save();
			ctx.lineWidth = Math.min(thickness, 8);
			ctx.beginPath();
			ctx.moveTo([0.29 * w, (3 * h) / 5]);
			ctx.quadraticCurveTo(0.43 * w, h / 5, w / 2, h / 2);
			ctx.quadraticCurveTo(0.57 * w, (3.5 * h) / 5, 0.71 * w, (2 * h) / 5);
			ctx.stroke();
			ctx.restore();
		},

		getVolumeIconType(enabled, volume) {
			if (!enabled || volume === 0) {
				return "off";
			}
			if (volume < 34) {
				return "low";
			}
			if (volume < 67) {
				return "medium";
			}
			return "on";
		},

		render: function() {
			const musicIconType = this.getVolumeIconType(
				this.state.musicEnabled,
				this.state.musicVolume
			);
			const musicIcon = (
				<div className={styles.button}>
					<img
						className={styles.volumeIcon}
						src={AssetsUtil.getVolumeIcon(musicIconType)}
						onClick={this.onMusicToggle}
					/>
				</div>
			);
			const soundIconType = this.getVolumeIconType(
				this.state.soundsEnabled,
				this.state.soundsVolume
			);
			const soundIcon = (
				<div className={styles.button}>
					<img
						className={styles.volumeIcon}
						src={AssetsUtil.getVolumeIcon(soundIconType)}
						onClick={this.onSoundToggle}
					/>
				</div>
			);
			const soundsValue = this.state.soundsEnabled
				? this.state.soundsVolume
				: 0;
			const musicValue = this.state.musicEnabled ? this.state.musicVolume : 0;

			return (
				<MessageModal
					onClose={this.onClose}
					backdropClass={styles.backdrop}
					modalClass={styles.main}
					styleType="default"
					levelType="aboveAll"
				>
					<div className={styles.title}>Settings</div>
					<div className={styles.section}>
						<div className={styles.header}>Sounds</div>
						{soundIcon}
						<div className={styles.sliderContainer}>
							<RangeSlider
								ref={ref => (this.soundsSlider = ref)}
								className={styles.slider}
								value={soundsValue}
								min={0}
								max={100}
								tooltip={false}
								step={1}
								orientation={"horizontal"}
								onChange={this.onSoundVolumeChange}
								onChangeComplete={() => Sounds.playSound("thud")}
							/>
						</div>
					</div>
					<div className={styles.section}>
						<div className={styles.header}>Music</div>
						{musicIcon}
						<div className={styles.sliderContainer}>
							<RangeSlider
								ref={ref => (this.musicSlider = ref)}
								className={styles.slider}
								value={musicValue}
								min={0}
								max={100}
								tooltip={false}
								step={1}
								orientation={"horizontal"}
								onChange={this.onMusicVolumeChange}
								onChangeComplete={() => Sounds.playSound("thud")}
							/>
						</div>
					</div>
					<div className={styles.section}>
						<div className={styles.header}>Pencil Color</div>
						<SettingsButtonContainer
							settingsField={"pencilLineColor"}
							buttonValues={this.pencilColors}
							buttonDrawFunctions={this.pencilColorFunctions}
							currentValue={this.state.pencilColor}
							onButtonClick={this.onPencilColorChange}
						/>
					</div>
					<div className={styles.section}>
						<div className={styles.header}>Pencil Line</div>
						<SettingsButtonContainer
							settingsField={"pencilLineWidth"}
							buttonValues={this.pencilLineWidths}
							buttonDrawFunctions={this.pencilLineWidthFunctions}
							currentValue={this.state.pencilLineWidth}
							onButtonClick={this.onPencilLineWidthChange}
						/>
					</div>
				</MessageModal>
			);
		},
	})
);
